





































































import { Component, Mixins } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";
import { prepareMoney } from "@/assets/scripts/utils";
import AccountDropdown from "@/components/for-page-grid/AccountDropdown.vue";
import ContractDropdown from "@/components/for-page-grid/ContractDropdown.vue";
import AppApiMixin from "../mixins/AppApi.vue";
import {AppealsByContract} from "@/models/appeals";

@Component({
  components: {
    AccountDropdown,
    ContractDropdown,
  },
  computed: {
    ...mapState({ currentContract: "contract" }),
    ...mapGetters("contract", {
      useContract: "useContract",
      contractBalance: "balance",
      contractId: "id"
    }),
    ...mapGetters("contracts", {
      sortedContractsByOrganization: "sortedContractsByOrganization",
    }),
    ...mapGetters("appeals", {
      appealsList: "appealsList",
    }),
  },
  filters: {
    prepareMoney(value: number) {
      return prepareMoney(value);
    },
  },
})

class AppBar extends Mixins(AppApiMixin) {
  baseGapClass = "mr-7";
  dropdownNudgeBottom = 60;

  mounted() {
  }
}

export default AppBar;
